module.exports = __webpack_public_path__ + "media/soon.9a4e4201.mp3";